<template>
  <footer v-show="isFooterBarVisible" class="footer">
    <div class="container-fluid">
      <div style="font-size: .8em;">
        <div class="columns">
          <div class="column">
            &copy; {{ year }} CaptureFit. All Rights Reserved.
          </div>
          <div class="column has-text-right">
            Powered by
            <a
              class="has-margin-left-5"
              href="https://naileddigital.com"
              target="_blank"
              >Nailed Digital</a
            >
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  name: 'FooterBar',
  computed: {
    year() {
      return moment().year()
    },
    ...mapState(['isFooterBarVisible'])
  }
}
</script>
